// DepartmentList.js - Fixed select all and display
import React, { useState, useEffect, useCallback } from 'react';
import { Select, Tag, Spin, message, Button } from 'antd';
import { request } from "../../share/request";
import { getCurrentUser } from "../../share/getProfile";

const { Option } = Select;

const DepartmentList = function(props) {
  var selectedDepartments = props.selectedDepartments || [];
  var onChange = props.onChange;
  var placeholder = props.placeholder || "ជ្រើសរើសនាយកដ្ឋាន...";
  var multiple = props.multiple !== undefined ? props.multiple : true;
  var orgCode = props.orgCode || null;
  var allowClear = props.allowClear !== undefined ? props.allowClear : true;
  var maxTagCount = props.maxTagCount || 'responsive';
  var showSelectAll = props.showSelectAll !== undefined ? props.showSelectAll : true;

  var getProfile = getCurrentUser();
  var _useState = useState([]);
  var departments = _useState[0];
  var setDepartments = _useState[1];
  var _useState2 = useState(false);
  var loading = _useState2[0];
  var setLoading = _useState2[1];
  var _useState3 = useState(null);
  var error = _useState3[0];
  var setError = _useState3[1];

  var fetchDepartments = useCallback(async function() {
    setLoading(true);
    setError(null);
    
    try {
      var param = new URLSearchParams();
      param.append("org_code", orgCode || getProfile.org_code);

      var res = await request("departmentall?" + param.toString(), "get", {});
      
      var deptList = [];

      if (res && res.listdepartment && Array.isArray(res.listdepartment)) {
        deptList = res.listdepartment;
      } else if (res && Array.isArray(res)) {
        deptList = res;
      } else if (res && res.data && Array.isArray(res.data)) {
        deptList = res.data;
      } else if (res && res.api_departments && Array.isArray(res.api_departments)) {
        deptList = res.api_departments;
      } else if (res && res.list && Array.isArray(res.list)) {
        deptList = res.list;
      }
      
      var formattedDepartments = deptList
        .filter(function(dept) { return dept; })
        .map(function(dept) {
          return {
            code: String(dept.code || dept.department_code || dept.id || ''),
            name: dept.department_name || dept.name || dept.department || 'Unknown',
            staff_count: dept.staff_count || dept.total_staff || 0,
          };
        })
        .filter(function(dept) { return dept.code; });
      
      setDepartments(formattedDepartments);
    } catch (err) {
      console.error("Error fetching departments:", err);
      setError("មិនអាចទាញយកបញ្ជីនាយកដ្ឋានបានទេ");
      message.error("មិនអាចទាញយកបញ្ជីនាយកដ្ឋានបានទេ");
    } finally {
      setLoading(false);
    }
  }, [getProfile.org_code, orgCode]);

  useEffect(function() {
    fetchDepartments();
  }, [fetchDepartments]);

  var handleChange = function(selectedValues) {
    if (multiple) {
      onChange(selectedValues || []);
    } else {
      onChange(selectedValues ? [selectedValues] : []);
    }
  };

  // FIXED: Select all logic
  var handleSelectAll = function(e) {
    e.stopPropagation();
    e.preventDefault();
    
    if (isAllSelected) {
      // Deselect all
      onChange([]);
    } else {
      // Select all
      var allCodes = departments.map(function(dept) { return dept.code; });
      onChange(allCodes);
    }
  };

  var handleDeselect = function(value) {
    if (multiple) {
      onChange(selectedDepartments.filter(function(code) { return code !== value; }));
    } else {
      onChange([]);
    }
  };

  // FIXED: Check if all departments are selected
  var isAllSelected = departments.length > 0 && 
    departments.every(function(dept) {
      return selectedDepartments.indexOf(dept.code) !== -1;
    });

  var getDepartmentByCode = function(code) {
    return departments.find(function(d) { return d.code === code; });
  };

  return React.createElement('div', { style: { } },
    React.createElement(Select, {
      mode: multiple ? "multiple" : undefined,
      value: multiple ? selectedDepartments : (selectedDepartments[0] || undefined),
      onChange: handleChange,
      onDeselect: handleDeselect,
      placeholder: placeholder,
      loading: loading,
      allowClear: allowClear,
      showSearch: true,
      maxTagCount: maxTagCount,
      maxTagPlaceholder: function(omittedValues) {
        return React.createElement(Tag, null, '+' + omittedValues.length + ' ទៀត');
      },
      filterOption: function(input, option) {
        var optionLabel = '';
        if (option && option.label) {
          optionLabel = String(option.label);
        }
        var inputLower = input.toLowerCase();
        return optionLabel.toLowerCase().indexOf(inputLower) !== -1;
      },
      style: { width: '100%' },
      notFoundContent: loading 
        ? React.createElement(Spin, { size: "small" })
        : 'មិនមាននាយកដ្ឋាន',
      dropdownRender: function(menu) {
        return React.createElement('div', null,
          multiple && showSelectAll && departments.length > 0 && React.createElement('div', {
            style: { 
              padding: '8px 12px', 
              borderBottom: '1px solid #f0f0f0', 
              cursor: 'pointer',
              userSelect: 'none'
            },
            onClick: handleSelectAll,
            onMouseDown: function(e) { e.preventDefault(); } // Prevent dropdown from closing
          },
            React.createElement('label', { 
              style: { 
                cursor: 'pointer', 
                display: 'flex', 
                alignItems: 'center',
                margin: 0
              }
            },
              React.createElement('input', { 
                type: "checkbox", 
                checked: isAllSelected, 
                readOnly: true, 
                style: { marginRight: 8, cursor: 'pointer' },
                onClick: function(e) { e.stopPropagation(); }
              }),
              React.createElement('span', null, 
                isAllSelected ? 'ដកចេញទាំងអស់' : 'ជ្រើសរើសទាំងអស់'
              ),
              React.createElement('span', { 
                style: { fontSize: '12px', color: '#999', marginLeft: 8 }
              }, '(' + departments.length + ' នាយកដ្ឋាន)')
            )
          ),
          React.createElement('div', { style: { maxHeight: '300px', overflowY: 'auto' } }, menu)
        );
      },
      tagRender: function(props) {
        var value = props.value;
        var closable = props.closable;
        var onClose = props.onClose;
        var dept = getDepartmentByCode(value);
        var displayName = dept ? dept.name : String(value || '');
        
        return React.createElement(Tag, {
          closable: closable,
          onClose: onClose,
          style: { marginRight: 3 }
        }, displayName);
      }
    },
      departments.map(function(dept) {
        return React.createElement(Option, { 
          key: dept.code, 
          value: dept.code,
          label: dept.name
        }, dept.name);
      })
    ),

    multiple && selectedDepartments.length > 0 && React.createElement('div', { 
      style: { marginTop: 8, fontSize: '13px', color: '#666' }
    },
 
    ),

    error && React.createElement('div', { 
      style: { color: '#ff4d4f', marginTop: 8, fontSize: '12px' }
    }, error)
  );
};

export default DepartmentList;